// extracted by mini-css-extract-plugin
export default {"searchFieldContainer":"lFhqs","focused":"zPX_Q","icon":"m9qSs"};